import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import moment from "moment";
import { ToasterService } from "@topline/services/toasterService";
import { ForecastService } from "../../services/forecastService";
(function (module) {
    "use strict";

    module.component("correctionAboutFacts", {
        template: require("./correctionAboutFactsComponent.html"),
        bindings: {
            forecast: "=",
            additionalForecast: "<",
            correctionService: "@",
            input: "=",
            output: "=",
            inputValue: "=",
            outputValue: "=",
            corrections: "=",
            parameters: "<",
            enter: "=",
            isSku: "<",
            isRf: "<",
            isEditable: "<",
            calculationRfCorrection: "@",
            compareForecast: "<",
            compareForecastTranslationKey: "<",
            freezedMonths: "<"
        },
        controller: [
            "$scope",
            "$injector",
            angularServicesNames.$translate,
            "dtpChartService",
            "PPGChartAndTableService",
            ForecastService.componentName,
            ToasterService.componentName,
            FileDownloadService.componentName,
            "forecastConfigurationService",
            angularServicesNames.$uibModal,
            "clipboardService",
            "selectElementAndConvertService",
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $injector: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                dtpChartService: $TSFixMe,
                PPGChartAndTableService: $TSFixMe,
                forecastService: ForecastService,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService,
                forecastConfigurationService: $TSFixMe,
                $uibModal: ng.ui.bootstrap.IModalService,
                clipboardService: $TSFixMe,
                selectElementAndConvertService: $TSFixMe
            ) {
                var $ctrl = this;

                $ctrl.showDataYears = true;

                $ctrl.coordinatesSelectedCells = null;

                $ctrl.tempSelectedArr = [];
                resetCorrectData();
                forecastService.getRisk().then(function (data) {
                    $ctrl.riskData = data;
                });

                $ctrl.searchCorrectionPrompt = (searchString: $TSFixMe, source: $TSFixMe) =>
                    forecastConfigurationService.searchCorrectionPrompt(searchString, source);

                function getCorrectionService() {
                    return $injector.get($ctrl.correctionService);
                }

                function resetCorrectData() {
                    $ctrl.correctData = {
                        impactType: "percentage"
                    };
                    $ctrl.attempted = false;
                }

                $scope.$on("LanguageChanged", () => resetChartTranslations());

                function resetChartTranslations() {
                    $translate([
                        "CHART_SERIES.FORECAST_BASE",
                        "CHART_SERIES.FORECAST_AFTER_FACTS",
                        $ctrl.compareForecastTranslationKey
                            ? $ctrl.compareForecastTranslationKey
                            : "FORECAST.CHART.PM_FORECAST_MARKET"
                    ]).then(function (translations: $TSFixMe) {
                        $ctrl.datasetOverride = [
                            {
                                label: translations["CHART_SERIES.FORECAST_BASE"],
                                yAxisID: "y-value"
                            },
                            {
                                label: translations["CHART_SERIES.FORECAST_AFTER_FACTS"],
                                yAxisID: "y-value"
                            },
                            {
                                label: translations[
                                    $ctrl.compareForecastTranslationKey
                                        ? $ctrl.compareForecastTranslationKey
                                        : "FORECAST.CHART.PM_FORECAST_MARKET"
                                ],
                                yAxisID: "y-value",
                                borderColor: "rgba(235,154,110, 1)",
                                backgroundColor: "rgba(235,154,110, 1)",
                                hidden: true
                            }
                        ];

                        $ctrl.forecastBaseSeries = translations["CHART_SERIES.FORECAST_BASE"];
                        $ctrl.forecastFactsSeries = translations["CHART_SERIES.FORECAST_AFTER_FACTS"];
                        $ctrl.series = [$ctrl.forecastBaseSeries, $ctrl.forecastFactsSeries];
                    });
                }

                function prepareStatisticSumData(data: $TSFixMe) {
                    for (var i = 0, max = data.length; i < max; i++) {
                        angular.forEach(data[i], function (value: $TSFixMe, key: $TSFixMe) {
                            if (key === "data") {
                                data[i].sumYear = dtpChartService.sumData(value, "forecast");
                                data[i].sumCorrectData = dtpChartService.sumCorrectData(value, "forecast");
                                data[i].sumCompareForecast = dtpChartService.sumData(value, "compareForecast");
                                data[i].quartersBase = PPGChartAndTableService.sumQuarters(value);
                                data[i].quartersAfterCorrect = PPGChartAndTableService.sumQuartersCorrect(value);
                            }
                        });
                    }
                }

                function prepareTooltipDescripiton(data: $TSFixMe) {
                    let result: $TSFixMe = [];
                    for (let i = 0, max = data.length; i < max; i++) {
                        angular.forEach(data[i], function (value: $TSFixMe, key: $TSFixMe) {
                            if (key === "data") {
                                for (let j = 0, end = value.length; j < end; j++) {
                                    if (value[j] && value[j].correctData) {
                                        result.push(value[j].correctData.name);
                                    } else if (!angular.isUndefinedOrNull(value[j])) {
                                        result.push(null);
                                    }
                                }
                            }
                        });
                    }
                    return result;
                }

                $ctrl.$onInit = function () {
                    if ($ctrl.isRf) {
                        $ctrl.coordinatesSelectedCells = {};
                        startWatchCoordinatesSelectedCells();
                    }
                    $ctrl.enter = function () {
                        $ctrl.datePickerOptions = {
                            minMode: "month",

                            minDate: moment
                                .utc($ctrl.parameters.forecastStartDate)
                                .add($ctrl.freezedMonths, "months")
                                .toDate(),
                            maxDate: $ctrl.parameters.forecastEndDate
                        };

                        $ctrl.labels = dtpChartService.preparePeriodsAndLabels(
                            $ctrl.parameters.forecastStartDate,
                            $ctrl.parameters.forecastEndDate
                        ).periods;
                        $ctrl.correctAboutFactsToChart = [$ctrl.input, $ctrl.output ? $ctrl.output : $ctrl.input];

                        if (!angular.isUndefinedOrNull($ctrl.isSku)) {
                            $ctrl.correctAboutFactsToChart.push($ctrl.additionalForecast);
                            $scope.$watch("$ctrl.additionalForecast", (newVal: $TSFixMe) => {
                                $ctrl.correctAboutFactsToChart[2] = newVal;
                            });
                        }

                        if (!angular.isUndefinedOrNull($ctrl.compareForecast)) {
                            $ctrl.correctAboutFactsToChart.push($ctrl.compareForecast);
                        }

                        $scope.$watch("$ctrl.output", function (newVal: $TSFixMe) {
                            var labels = dtpChartService.preparePeriodsAndLabels(
                                $ctrl.parameters.forecastStartDate,
                                $ctrl.parameters.forecastEndDate
                            ).periods;
                            if (labels) {
                                refreshFromModel();
                                $ctrl.correctAboutFactsToChart[1] = newVal ? newVal : $ctrl.input;
                            }
                        });
                        resetChartTranslations();
                    };

                    $scope.$watch("$ctrl.freezedMonths", (freezedMonths: $TSFixMe) => {
                        if (angular.isNumber(freezedMonths)) {
                            if (!$ctrl.datePickerOptions) {
                                $ctrl.datePickerOptions = {};
                            }

                            $ctrl.datePickerOptions.minDate = moment
                                .utc($ctrl.parameters.forecastStartDate)
                                .add(freezedMonths, "months")
                                .toDate();
                        }
                    });

                    $ctrl.options = {
                        scales: {
                            yAxes: [
                                {
                                    id: "y-value",
                                    display: true,
                                    position: "left",
                                    ticks: {
                                        suggestedMin: 0
                                    }
                                }
                            ]
                        },
                        tooltips: {
                            callbacks: {
                                label: function (tooltipItem: $TSFixMe, data: $TSFixMe) {
                                    let label = data.datasets[tooltipItem.datasetIndex].label || "";

                                    if (label) {
                                        label += ": ";
                                    }
                                    label += tooltipItem.yLabel.toFixed(2);
                                    return label.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                                },
                                footer: (tooltipItem: $TSFixMe) => {
                                    if ($ctrl.nameToTooltip[tooltipItem[0].index]) {
                                        return (
                                            $translate.instant("MARKET.NAME") +
                                            " " +
                                            $ctrl.nameToTooltip[tooltipItem[0].index]
                                        );
                                    }
                                }
                            }
                        }
                    };

                    if (!angular.isUndefinedOrNull($ctrl.isSku)) {
                        $ctrl.options.scales.yAxes.push({
                            id: "y-value",
                            display: true,
                            ticks: {
                                suggestedMin: 0
                            }
                        });
                    }

                    $ctrl.addCorrect = function (obj: $TSFixMe) {
                        $ctrl.attempted = true;
                        if ($ctrl.correctDataForm.$valid) {
                            getCorrectionService()
                                .updateCorrect(obj, $ctrl.forecast, $ctrl.parameters)
                                .then(() => refreshFromModel());
                            resetCorrectData();
                            $ctrl.correctDataForm.$setUntouched();
                        } else {
                            for (const control of $ctrl.correctDataForm.$$controls) {
                                control.$setTouched();
                            }
                        }
                    };

                    $ctrl.addZero = function () {
                        $ctrl.attempted = true;
                        if (
                            $ctrl.correctDataForm["name"].$valid &&
                            $ctrl.correctDataForm["desc"].$valid &&
                            $ctrl.correctDataForm["startDate"].$valid &&
                            $ctrl.correctDataForm["endDate"].$valid
                        ) {
                            getCorrectionService()
                                .updateCorrect(
                                    {
                                        impactType: "explicit",
                                        impact: 0,
                                        startDate: $ctrl.correctData.startDate,
                                        endDate: $ctrl.correctData.endDate,
                                        name: $ctrl.correctData.name,
                                        desc: $ctrl.correctData.desc
                                    },
                                    $ctrl.forecast,
                                    $ctrl.parameters
                                )
                                .then(() => refreshFromModel());
                            resetCorrectData();
                            $ctrl.correctDataForm.$setUntouched();
                        } else {
                            $ctrl.correctDataForm.$setUntouched();
                            $ctrl.correctDataForm["name"].$setTouched();
                            $ctrl.correctDataForm["desc"].$setTouched();
                            $ctrl.correctDataForm["startDate"].$setTouched();
                            $ctrl.correctDataForm["endDate"].$setTouched();
                        }
                    };

                    $ctrl.clearCorrect = function () {
                        resetCorrectData();
                        $ctrl.correctDataForm.$setUntouched();
                    };

                    $ctrl.removeCorrect = function (start: $TSFixMe, end: $TSFixMe) {
                        removeData(start, end);
                        $ctrl.startRemove = null;
                        $ctrl.endRemove = null;
                        $ctrl.removeItemForm.$setUntouched();
                    };

                    $ctrl.removeCorrectData = () => {
                        if (!$ctrl.isEditable) {
                            return;
                        }

                        const date = rangeDate($ctrl.parameters.forecastStartDate, $ctrl.tempSelectedArr);
                        removeData(date.start, date.end);
                        $ctrl.correctData.startDate = null;
                        $ctrl.correctData.endDate = null;
                        $ctrl.clearCorrect();
                    };

                    function removeData(start: $TSFixMe, end: $TSFixMe) {
                        getCorrectionService()
                            .removeCorrect(start, end, $ctrl.forecast, $ctrl.parameters)
                            .then(() => refreshFromModel());
                    }

                    function refreshFromModel() {
                        if ($ctrl.input) {
                            $ctrl.forecastData = PPGChartAndTableService.prepareDataToForecastTable(
                                $ctrl.parameters,
                                $ctrl.input,
                                $ctrl.output,
                                $ctrl.corrections,
                                $ctrl.compareForecast
                            );
                            prepareStatisticSumData($ctrl.forecastData);
                            $ctrl.nameToTooltip = prepareTooltipDescripiton($ctrl.forecastData);
                        }
                    }

                    $ctrl.showDetails = function (details: $TSFixMe, event: $TSFixMe) {
                        // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                        enablePasting(event);

                        $ctrl.correctData = angular.copy(details);
                        $ctrl.selected = null;
                        $ctrl.tempSelectedArr = [];
                        unmarkSelectedItems($ctrl.forecastData);
                        event.stopPropagation();
                    };

                    $ctrl.sellectCells = (item: $TSFixMe) => {
                        if (!$ctrl.tempSelectedArr || $ctrl.tempSelectedArr.length < 2) {
                            unmarkSelectedItems($ctrl.forecastData);
                            $ctrl.selected = item;
                            $ctrl.tempSelectedArr = [item];
                            markSelectedItems($ctrl.forecastData, $ctrl.tempSelectedArr);
                        } else {
                            let itemIsOutsideOfSelectedRange =
                                item.index < $ctrl.tempSelectedArr[0].index ||
                                item.index > $ctrl.tempSelectedArr[1].index;
                            if (itemIsOutsideOfSelectedRange) {
                                unmarkSelectedItems($ctrl.forecastData);
                                $ctrl.selected = item;
                                $ctrl.tempSelectedArr = [item];
                                markSelectedItems($ctrl.forecastData, $ctrl.tempSelectedArr);
                            }
                        }
                    };

                    $ctrl.selectItem = (item: $TSFixMe, event: $TSFixMe) => {
                        // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
                        enablePasting(event);

                        if (!$ctrl.isEditable) {
                            return;
                        }

                        if (!item.correctData) {
                            $ctrl.clearCorrect();
                        }
                        selectHandler(item, event);
                        updateFormDateField();
                    };

                    function selectHandler(item: $TSFixMe, event: $TSFixMe) {
                        if (event.shiftKey) {
                            $ctrl.tempSelectedArr.push(item);
                            markSelectedItems($ctrl.forecastData, $ctrl.tempSelectedArr);
                            updateFormDateField();
                        } else {
                            $ctrl.selected = item;
                            if ($ctrl.tempSelectedArr.length) {
                                $ctrl.tempSelectedArr = [];
                            }
                            unmarkSelectedItems($ctrl.forecastData);
                            $ctrl.tempSelectedArr.push(item);
                        }
                    }

                    function updateFormDateField() {
                        const date = rangeDate($ctrl.parameters.forecastStartDate, $ctrl.tempSelectedArr);
                        $ctrl.correctData.startDate = date.start;
                        $ctrl.correctData.endDate = date.end;
                    }

                    function unmarkSelectedItems(arr: $TSFixMe) {
                        angular.forEach(arr, (x: $TSFixMe) => {
                            for (let i = 0, max = x.data.length; i < max; i++) {
                                if (x.data[i] && x.data[i].selected) {
                                    delete x.data[i].selected;
                                }
                            }
                        });
                    }

                    function markSelectedItems(arr: $TSFixMe, selectedArr: $TSFixMe) {
                        selectedArr.sort((a: $TSFixMe, b: $TSFixMe) =>
                            a.index > b.index ? 1 : b.index > a.index ? -1 : 0
                        );
                        const firstElementToSelect = selectedArr[0].index,
                            lastElementToSelect = selectedArr[selectedArr.length - 1].index;

                        angular.forEach(arr, (x: $TSFixMe) => {
                            for (let i = 0, max = x.data.length; i < max; i++) {
                                if (
                                    x.data[i] &&
                                    x.data[i].index >= firstElementToSelect &&
                                    x.data[i].index <= lastElementToSelect
                                ) {
                                    x.data[i].selected = true;
                                }
                            }
                        });
                    }

                    function rangeDate(forecastStart: $TSFixMe, dateArr: $TSFixMe) {
                        return {
                            start: moment.utc(forecastStart).add(dateArr[0].index, "months").toDate(),

                            end: moment
                                .utc(forecastStart)
                                .add(dateArr[dateArr.length - 1].index, "months")
                                .toDate()
                        };
                    }

                    $ctrl.isSelected = (item: $TSFixMe) => item === $ctrl.selected;

                    $ctrl.exportTable = () => {
                        toasterService.showReportGenerateBusyIndicator(
                            () =>
                                fileDownloadService.exportTable(
                                    "table.xlsx",
                                    PPGChartAndTableService.getCorrectionAboutFactForTableExport($ctrl.forecastData)
                                ),
                            "EXCEL_EXPORT_GENERATING",
                            "EXCEL_EXPORT_GENERATED"
                        );
                    };

                    $ctrl.displayErrorOnField = (field: $TSFixMe) => {
                        return $ctrl.attempted && field.$touched && field.$invalid;
                    };

                    function enablePasting() {
                        const targetElement = angular.element(event!.target!);
                        const input = targetElement.find("input.pastable-input").length
                            ? targetElement.find("input.pastable-input")
                            : targetElement.siblings("input.pastable-input");
                        input.focus();
                    }

                    function startWatchCoordinatesSelectedCells() {
                        $scope.$watch(
                            "$ctrl.coordinatesSelectedCells",
                            function (nValue: $TSFixMe, oValue: $TSFixMe) {
                                if (!_.isEmpty(nValue)) {
                                    const data = selectElementAndConvertService.pickElementFromArray(
                                        $ctrl.coordinatesSelectedCells,
                                        $ctrl.forecastData,
                                        "data"
                                    );
                                    $ctrl.dataToResume = selectElementAndConvertService.setArithmeticAverage(
                                        data,
                                        ["forecast", "correctData"],
                                        "correct"
                                    );
                                    $ctrl.showSpecialElement = true;
                                } else {
                                    $ctrl.showSpecialElement = false;
                                }
                            },
                            true
                        );
                    }

                    $ctrl.onPaste = (event: $TSFixMe) => {
                        if (!$ctrl.isEditable) {
                            return;
                        }

                        const maxAllowedNumberOfCorrects = dtpChartService.getPeriodLenghtInMonths(
                            $ctrl.correctData.startDate,
                            $ctrl.parameters.forecastEndDate
                        );

                        let values = clipboardService.getData(event.originalEvent.clipboardData);
                        values.splice(maxAllowedNumberOfCorrects);

                        if (values && values.length) {
                            const modalInstance = $uibModal.open({
                                component: "correctionAboutFactsBatchEdit",
                                resolve: {
                                    inputData: () => values,
                                    withName: () => true,
                                    isRf: () => $ctrl.isRf
                                }
                            });

                            modalInstance.result.then(function (correctionInfo: $TSFixMe) {
                                let date = $ctrl.correctData.startDate;
                                values.forEach((p: $TSFixMe) => {
                                    getCorrectionService()
                                        .updateCorrect(
                                            {
                                                impactType: "explicit",
                                                impact: p,
                                                startDate: date,
                                                endDate: date,
                                                name: correctionInfo.name,
                                                desc: correctionInfo.desc
                                            },
                                            $ctrl.forecast,
                                            $ctrl.parameters
                                        )
                                        .then(() => refreshFromModel());

                                    date = moment.utc(date).add(1, "M").toDate();
                                });
                            });
                        }
                    };
                };
            }
        ]
    });
})(angular.module("topline.modules"));
